import Drawable from '../entities/Drawable.js';
import PixelText from './PixelText.js';
import Sprite from './Sprite.js';
import StatusBadge from './StatusBadge.js';
import { imageStore } from '../images.js';
import { spriteStore } from '../images.js';
import { c } from '../setup.js';

export default class PrimaryPokemonBox extends Drawable {
    constructor({ pokemonMenu, pokemon = null, position = { x: 0, y: 0 }, visible = true }) {
        super();
        this.pokemonMenu = pokemonMenu;
        this.pokemon = pokemon;
        this.sprites = {};
        this.position = position;
        this.visible = visible;
        this.sprites.background = spriteStore.store.pokemonMenuPrimaryBox;
        this.sprites.background.position = position;
        this.sprites.pokemonIcon = null;
        // this.sprites.pokemonIcon.spriteIndex = null;
        // this.sprites.pokemonIcon.position = { x: this.position.x - 6, y: this.position.y + 10 };
        this.canLearnMoveText = new PixelText({
            text: 'ABLE',
            position: { x: this.position.x + 30, y: this.position.y + 19 - 7 },
            color: 'white',
        });
        this.pokemonNameText = new PixelText({
            text: '',
            position: { x: this.position.x + 30, y: this.position.y + 29 - 7 },
            color: 'white',
        });
        this.pokemonLevelText = new PixelText({
            text: '',
            position: { x: this.position.x + 38, y: this.position.y + 37 - 7 },
            color: 'white',
        });

        const genderString = '';
        const genderColor = 'black';

        const levelTextWidth = this.pokemonLevelText.getWidth();

        this.pokemonGenderText = new PixelText({
            text: genderString,
            position: {
                x: this.pokemonLevelText.position.x + levelTextWidth,
                y: this.pokemonLevelText.position.y - 7,
            },
            color: genderColor,
        });
        this.pokemonHpText = new PixelText({
            text: ``,
            textAlign: 'right',
            position: { x: this.position.x + 78, y: this.position.y + 53 - 7 },
            color: 'white',
        });
        this.animationCursor = 0;
        this.sprites.statusBadge = new StatusBadge({
            position: { x: 16, y: 16 },
            visible: true,
            status: this.pokemon?.status1 ? this.pokemon.status1.id : 'blank',
        });
        this.sprites.heldItemIcon = new Sprite({
            position: { x: this.position.x + 15, y: this.position.y + 29 },
            image: imageStore.get('img/held_item.png'),
            visible: false,
            moving: false,
        });
    }

    draw() {
        if (this.pokemon === null) {
            return;
        }
        this.visible = this.pokemonMenu.visible;
        if (!this.visible) {
            return;
        }
        this.pokemon = this.pokemonMenu.partyPokemon[0];
        this.pokemonNameText.text = this.pokemon.nickname || this.pokemon.name;
        this.pokemonLevelText.text = `Lv${this.pokemon.level}`;
        this.sprites.pokemonIcon = this.pokemon.icon;
        this.sprites.pokemonIcon.spriteIndex = this.pokemon.id - 1;
        this.sprites.pokemonIcon.visible = true;
        this.sprites.pokemonIcon.position = { x: this.position.x - 6, y: this.position.y + 10 };
        this.sprites.background.visible = this.pokemonMenu.visible;
        const currentlySelected = this.pokemonMenu.currentOption === 0;

        this.animationCursor += 1;
        if (this.animationCursor > 30) {
            this.animationCursor = 0;
        }

        if (this.animationCursor < 15) {
            this.sprites.pokemonIcon.position.y = this.position.y + 8;
        } else {
            this.sprites.pokemonIcon.position.y = this.position.y + (currentlySelected ? 4 : 7);
        }

        this.sprites.background.frames.val = currentlySelected ? 0 : 1;
        this.sprites.background.draw();
        this.sprites.pokemonIcon.draw();
        if (this.pokemonMenu.shouldShowMoveLearnability) {
            const moveToBeLearned = this.pokemonMenu.GUI.stateMachine.context.currentMove;
            this.canLearnMoveText.text = this.pokemon.moveLearnabilityText(moveToBeLearned);
            this.canLearnMoveText.draw();
        } else {
            this.canLearnMoveText.text = '';
        }
        this.pokemonNameText.draw();
        if (!this.pokemon.status1) {
            this.pokemonLevelText.draw();
            this.pokemonGenderText.draw();
        }
        this.pokemonHpText.text = `${this.pokemon.stats.hp}/${this.pokemon.stats.maxHp}`;
        this.pokemonHpText.draw();
        const barShouldBeRed = this.pokemon.stats.hp < this.pokemon.stats.maxHp * 0.2;
        const barShouldBeYellow = this.pokemon.stats.hp < this.pokemon.stats.maxHp * 0.5;

        c.fillStyle = Drawable.blackBarColor;
        c.fillRect(this.position.x + 30, this.position.y + 41, 48, 3);

        // Health Bar
        c.fillStyle = barShouldBeRed
            ? Drawable.redBarColor
            : barShouldBeYellow
            ? Drawable.yellowBarColor
            : Drawable.greenBarColor;
        c.fillRect(
            this.position.x + 30,
            this.position.y + 41,
            Math.ceil(48 * (this.pokemon.stats.hp / this.pokemon.stats.maxHp)),
            3
        );
        c.fillStyle = barShouldBeRed
            ? Drawable.redBarShadow
            : barShouldBeYellow
            ? Drawable.yellowBarShadow
            : Drawable.greenBarShadow;
        c.fillRect(
            this.position.x + 30,
            this.position.y + 41,
            Math.ceil(48 * (this.pokemon.stats.hp / this.pokemon.stats.maxHp)),
            1
        );
        if (this.pokemon.status1) {
            this.sprites.statusBadge.visible = true;
            this.sprites.statusBadge.status = this.pokemon.status1.id;
            this.sprites.statusBadge.position = {
                x: this.position.x + 30,
                y: this.position.y + 30,
            };
            this.sprites.statusBadge.draw();
        }
        if (this.pokemon.heldItem) {
            this.sprites.heldItemIcon.visible = true;
            this.sprites.heldItemIcon.draw();
        } else {
            this.sprites.heldItemIcon.visible = false;
        }
    }
}
